<template lang="pug">
.details
  p.section-title Booking details
    BriqButton(
      :disabled="checkedIn"
      @click="updateCheckIn"
      data-test-id="check-in-btn"
      )
      span.mr-5(v-if="checkedIn")
        BriqIcon(name="icon-input-checkbox-icon")
      span {{ checkedInButtonText }}
  .panel
    .payment-status.flex
      .w-50
        .payment
          BriqIcon(
            :name="`icon-creditcard-${paymentStatus.color}-planboard-overview`"
            customStyle="margin-right: 5px; margin-top: 5px;"
            data-test-id="payment-creditcard-icon"
            )
          span(
            :class="`payment-status-${paymentStatus.color}`"
            data-test-id="payment-status"
            ) {{ paymentStatus.text }} paid
      .w-50
        .checked-in
          BriqIcon(
            :name="`icon-participant-${checkedInStatusColor}-planboard-overview`"
            data-test-id="participant-icon"
            )
          span(
            :class="checkedIn ? 'payment-status-green' : 'payment-status-gray'"
            data-test-id="checked-in-status"
            ) {{ checkedInText }}
    .customer.flex
      .w-50
        p.customer-name.text-ellipsis(
          data-test-id="customer-name"
          :title="`${customerName}`"
          ) {{ customerName }}
        p.overview-label Customer name
      .w-50
        p(data-test-id="booking-number") {{ booking.Number }}
        p.overview-label Booking number
    .flex.mt-10(v-if="company")
      .company
        p(data-test-id="company") {{ company }}
        p.overview-label Company Inc.
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'OverviewDetails',
  props: {
    booking: {
      type: Object,
      required: true,
    },
    customerName: {
      type: String,
      required: true,
    },
    company: {
      type: String,
      default: '',
    },
  },
  computed: {
    checkedIn: {
      get() {
        return this.booking.CheckedIn
      },
      set(newVal) {
        this.booking.CheckedIn = newVal
      },
    },
    checkedInStatusColor() {
      return this.checkedIn ? 'green' : 'gray'
    },
    checkedInText() {
      const checkedInText = !this.checkedIn ? 'not checked in' : 'checked in'
      return `${this.booking.NumberOfPersons} ${checkedInText}`
    },
    paymentStatus() {
      return this.booking.AmountPaid === 0
        ? { color: 'gray', text: 'Not' }
        : this.booking.AmountPaid < this.booking.AmountTotal
          ? { color: 'orange', text: 'Partially' }
          : { color: 'green', text: 'Fully' }
    },
    checkedInButtonText() {
      return this.checkedIn ? 'Checked In' : 'Check In'
    },
  },
  methods: {
    ...mapActions('planboardModule', ['markAsCheckedIn']),
    async updateCheckIn() {
      const checkedInResponse = await this.markAsCheckedIn()
      if (checkedInResponse) {
        this.checkedIn = true
        this.$notifySuccess('Booking checked in!')
      } else {
        this.$notifyError('Something went wrong while checking in')
      }
    },
  },
}
</script>

<style lang="stylus">
.details
  .section-title
    display flex
    align-items flex-end

    button
      margin-left auto
      margin-right 0

  .overview-label
    font-size 12px
    line-height 16px
    color #96999D

  .payment-status
    margin-bottom 10px

  .payment, .checked-in
    display flex
    align-items center

    svg
      width 25px
      height 25px

    span
      font-size 12px
      line-height 16px
      font-style italic

    .payment-status-green
      color #3E9E00

    .payment-status-gray
      color #798696

    .payment-status-orange
      color #FFB229
</style>
